import * as React from 'react'

import { observer } from 'mobx-react'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import type Holidays from 'modules/shift_management/store/internal/collections/Holidays'
import type Leaves from 'modules/shift_management/store/internal/collections/Leaves'
import type RestDays from 'modules/shift_management/store/internal/collections/RestDays'

import Content from './Content'

interface Props {
  open: boolean
  selectedDate: moment.Moment
  onClose: () => void
  // TODO: Avoid undefined once the migration 'dev_shift_management_work_areas_graphql_migration' is done
  leaves: Leaves | undefined
  restDays: RestDays | undefined
  holidays: Holidays
}

const TimeoffSidepanel = ({ open, selectedDate, onClose, leaves, restDays, holidays }: Props) => {
  return (
    <Sidepanel
      title={i18n.t('shift_management.sidepanel.title')}
      open={open}
      onClose={onClose}
      closeLabel={i18n.t('common.close')}
      overlay={false}
      width="wide"
    >
      <Content
        selectedDate={selectedDate}
        leaves={leaves}
        restDays={restDays}
        holidays={holidays}
      />
    </Sidepanel>
  )
}

export default observer(TimeoffSidepanel)
